module.exports = __webpack_public_path__ + "static/media/bg-data-animate.21f2c55f.png";